export default "<div class=\"scroll_logo\">\n  <img src=\"/assets/img/lemonfish_smile.svg\" />\n</div>\n"